import Navbar from './components/Navbar/Navbar';
import FlowerCalculator from './components/FlowerCalculator/FlowerCalculator';
import bgImage from './assets/bgImage.jpg';
import './fonts/njnaruto.ttf';
import './App.css';

function App() {
  const styles = {
    backgroundImage: `url(${bgImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '100vw',
    height: '100vh',
    overflowX: 'hidden',
  };
  return (
    <div style={styles}>
      <Navbar />
      <FlowerCalculator />
    </div>
  );
}

export default App;

